import type { GymPhoto } from '@atomfit/shared';
import { apiClient } from './client.js';

export function photoUrl(path: string) {
  const base = new URL(`${apiClient.defaults.baseURL}/`, window.location.origin);
  return new URL(path.replace(/^\/api\/v1\//, ''), base).href;
}
const adminPath = (gymId: string) => `/owner/gyms/${gymId}/photos`;
const headers = (tenantSlug?: string) => (tenantSlug ? { 'X-Tenant-ID': tenantSlug } : {});
export const gymPhotosApi = {
  list: (gymId: string, signal?: AbortSignal) =>
    apiClient.get<GymPhoto[]>(`/gyms/${gymId}/photos`, { ...(signal ? { signal } : {}) }),
  adminList: (gymId: string, tenantSlug?: string, signal?: AbortSignal) =>
    apiClient.get<GymPhoto[]>(adminPath(gymId), {
      headers: headers(tenantSlug),
      ...(signal ? { signal } : {}),
    }),
  upload: (
    gymId: string,
    file: File,
    tenantSlug: string | undefined,
    onProgress: (percent: number) => void,
    signal: AbortSignal,
  ) => {
    const body = new FormData();
    body.append('photo', file);
    return apiClient.post<GymPhoto>(adminPath(gymId), body, {
      headers: { ...headers(tenantSlug), 'Content-Type': null },
      signal,
      onUploadProgress: (event) =>
        onProgress(Math.round((event.loaded / (event.total || file.size)) * 100)),
    });
  },
  order: (gymId: string, ids: string[], tenantSlug?: string) =>
    apiClient.put<GymPhoto[]>(
      `${adminPath(gymId)}/order`,
      { ids },
      { headers: headers(tenantSlug) },
    ),
  delete: (gymId: string, id: string, tenantSlug?: string) =>
    apiClient.delete(`${adminPath(gymId)}/${id}`, { headers: headers(tenantSlug) }),
  image: (url: string, tenantSlug: string | undefined, signal: AbortSignal) =>
    apiClient.get<Blob>(photoUrl(url), {
      responseType: 'blob',
      headers: headers(tenantSlug),
      signal,
    }),
};
